import { IonCol, IonRow, IonText } from '@ionic/react';

import styles from './HighlightAlinea.module.css';

import { Icon, IconName } from '../Icon';
import { IconSize } from '../Icon/types';

interface HighlightAlineaProps {
  children: React.ReactNode;
  icon: IconName;
  title: string;
  iconColor?: string;
}

export const HighlightAlinea = ({ icon, children, title, iconColor }: HighlightAlineaProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.Text}>
        <div className={styles.ArticleHighlightHeader}>
          <Icon color={iconColor} name={icon} size={IconSize.extraLarge} />
          <span className={styles.title}>{title}</span>
        </div>
        <IonRow>
          <IonCol>
            <IonText className={styles.txt}>{children}</IonText>
          </IonCol>
        </IonRow>
      </div>
    </div>
  );
};
